import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

export const STYLE_GROUPS_BY_ASSET_TYPE = {
  [ASSET_TYPE.THREE_D_ONLY]: [
    { key: 'look', styles: ['realistic', 'stylized_low_poly', 'cartoon_anime'] },
    { key: 'aesthetic', styles: ['modern', 'minimalist_abstract', 'classic_vintage', 'industrial'] },
    { key: 'theme', styles: ['fantasy_sci_fi', 'historical_military'] },
  ],
  [ASSET_TYPE.THREE_D_PRINT_ONLY]: [
    { key: 'aesthetic', styles: ['classic_vintage', 'modern_industrial', 'minimalist_abstract', 'elegant_ornate'] },
    { key: 'look', styles: ['realistic', 'stylized', 'cartoon_anime'] },
    { key: 'theme', styles: ['fantasy_sci_fi', 'historical_military'] },
  ],
}

export const MIN_STYLE_RESULTS = 20

export const getStyleGroupsForAssetType = (assetType) => STYLE_GROUPS_BY_ASSET_TYPE[assetType] || []

export const getStylesForAssetType = (assetType) => (
  getStyleGroupsForAssetType(assetType).flatMap(group => group.styles)
)
